<template>
  <div class="p-d-flex p-ai-center" v-if="user">
    <CustomerStatusHistoryButton
        :isChangeable="isChangeableStatus"
        @change-customer-status="changeCustomerStatus"
        :customerStatus="user.customerStatus"
        :customerId="user.id"/>

    <span class="customer-identity">
      <router-link :to="{ path: `/customers/${user.uid}` }"
                   :target="settings.openAllLinksInSameTab ? '_self' : '_blank'"
                   rel="noopener"
                   draggable="false">

        <template v-if="user.type === constants.userTypes.legal_entity && user.company_name">
          {{ user.company_name }}
        </template>

        <template v-else>
          {{ customerName(user) }}
        </template>
      </router-link>
      <UserLanguageBadge v-if="user.type !== constants.userTypes.legal_entity || !user.company_name"
                         :language="user.language"/>
    </span>
  </div>

  <i v-else class="ti-minus"/>
</template>
<script>
import UserLanguageBadge from "@/components/UserLanguageBadge.vue";
import CustomerStatusHistoryButton from "@/pages/users/components/CustomerStatusHistoryButton.vue";
import constants from "@/constants";
import settings from "@/settings";

export default {
  name: 'CustomerData',
  emits: ['change-customer-status'],
  components: { CustomerStatusHistoryButton, UserLanguageBadge },
  props: {
    user: {
      type: Object,
      default: null,
    },
    isChangeableStatus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      constants,
      settings
    }
  },
  methods: {
    customerName(user) {
      return [user?.first_name, user?.last_name].filter(Boolean).join(' ') || this.$t('Undefined')
    },
    changeCustomerStatus(newCustomerStatus, customerId, comment) {
      this.$emit(
          'change-customer-status',
          newCustomerStatus,
          customerId,
          comment
      );
    }
  }
}
</script>
<style scoped>
.customer-identity {
  min-width: 0;
  white-space: normal;
}

.customer-identity a {
  display: inline;
  white-space: normal;
}
</style>